<template>
    <label class="form-checkbox m-0 flex cursor-pointer items-center gap-x-1.5 select-none shrink-0">
        <input v-model="model" type="checkbox" :name="name" :value="value" :disabled="disabled" class="hidden" />

        <div class="border-2 border-turquoise-light flex size-4 items-center justify-center">
            <div class="bg-turquoise-light/0 size-2.5"></div>
        </div>

        <span class="text-sm text-gray">{{ label }}</span>
    </label>
</template>

<script setup>
const model = defineModel({ type: [Boolean, Number, String, Array] });

defineProps({
    name: { type: String, default: null },
    value: { type: [Number, String], required: true },
    disabled: { type: [Boolean], default: false },
    label: { type: String, required: true },
});
</script>

<style>
@reference '../../../styles/pappasrw.css';

.form-checkbox:has(:checked) > div div {
    @apply bg-turquoise-light;
}
</style>
